module.exports = __webpack_public_path__ + "img/plantfactory_logo.64d30b2d.png";